import { Layout } from '../../../components/common/Layout';

export const HonorDetail = () => {
  return <Layout>HonorDetail</Layout>;
};
